//权限模块

//引入接口文档
import req from '@/utils/req.js'


//权限菜单获取
export function api_permissionlist(params) {
    return req.get("/admin/resource",params);
}

//权限菜单详情
export function api_edit_btn(id) {
    return req.get(`/admin/resource/${id}`);
}


//权限菜单编辑
export function api_edilpermissionlist(params) {
    return req.put("/admin/resource",params);
}


//权限菜单添加
export function api_addpermissionlist(params) {
    return req.post("/admin/resource",params);
}

//权限菜单删除
export function api_delpermissionlist(id) {
    return req.delete(`/admin/resource/${id}`);
}



